export const LeftArrowIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.525 23.8333C19.2728 23.8342 19.0338 23.7208 18.875 23.525L14.85 18.525C14.5972 18.2175 14.5972 17.7742 14.85 17.4667L19.0166 12.4667C19.3112 12.1123 19.8373 12.0638 20.1916 12.3583C20.546 12.6529 20.5945 13.179 20.3 13.5333L16.575 18L20.175 22.4667C20.3831 22.7164 20.4269 23.0644 20.2873 23.358C20.1476 23.6516 19.85 23.8371 19.525 23.8333Z"
        fill="#919EAB"
        fill-opacity="0.8"
      />
    </svg>
  );
};

export default LeftArrowIcon;
